export default __webpack_public_path__ + "static/media/promotionDate.5095191e.svg";